import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/progressTracking`;
const token = localStorage.getItem("token");

// Récupérer toutes les étapes de progression groupées par association
export const getAllProgressTrackingPhases = async () => {
  try {
    const response = await axios.get(`${apiUrl}/AllProgressTrackingPhases`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du suivi des phases :", error);
    return [];
  }
};

export const togglePhaseStatus = async (id) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/togglePhaseStatus/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // renvoie { message, newStatus }
  } catch (error) {
    console.error("Erreur lors du basculement du statut de la phase :", error);
    return null;
  }
};
